module.exports = __webpack_public_path__ + "0e53aca3cd635b3378bf31e455ca23c5.svg";